// @ts-strict-ignore
import Image from 'next/image'
import Link from 'next/link'
import { useLayoutEffect, useState } from 'react'

import { Skeleton } from '@/shared/ui/Skeleton'

import styles from './CustomImageBanner.module.scss'

export type BannerProps = {
	imgSrcDesk: string
	imgSrcMob: string
	imgSrcTablet?: string
	imgAlt?: string
	link?: string
	imgDeskWidth: number
	imgMobWidth: number
	imgDeskHeight: number
	imgMobHeight: number
	imgTabletWidth?: number
	imgTabletHeight?: number
	title?: string
	withoutTablet?: boolean
	maxWidth?: string
	disabled?: boolean
	onClick?: () => void
	className?: string
	lazy?: boolean
	style?: any
	priority?: boolean
	fill?: boolean
}

export const CustomImageBanner = ({
	imgSrcDesk,
	imgSrcTablet,
	imgSrcMob,
	imgAlt = `alt`,
	imgDeskHeight,
	imgDeskWidth,
	imgTabletHeight,
	imgTabletWidth,
	imgMobHeight,
	imgMobWidth,
	title = ``,
	withoutTablet,
	onClick,
	className,
	maxWidth = '1440px',
	lazy,
	disabled,
	link,
	style,
	priority,
	fill
}: BannerProps): JSX.Element => {
	const [isSSR, setIsSSR] = useState(true)

	useLayoutEffect(() => {
		setIsSSR(false)
	}, [])

	// Determine screen size
	const isTablet =
		!isSSR && !withoutTablet && typeof window !== 'undefined' && window.innerWidth <= 1150 && window.innerWidth > 600
	const isDesktop = isSSR || (typeof window !== 'undefined' && window.innerWidth > 1150)

	// Select only ONE image based on screen size
	const selectedImage = isDesktop
		? { src: imgSrcDesk, width: imgDeskWidth, height: imgDeskHeight }
		: isTablet
		? { src: imgSrcTablet || imgSrcMob, width: imgTabletWidth || imgMobWidth, height: imgTabletHeight || imgMobHeight }
		: { src: imgSrcMob, width: imgMobWidth, height: imgMobHeight }

	const bannerContent = (
		<article
			className={`${styles.banner} ${fill ? styles._fill : ''} ${!link || disabled ? styles.disabled : ''} ${
				className || ''
			}`}
			title={`Перейти на страницу «${title}»`}
			onClick={!disabled ? onClick : undefined}
			style={fill ? style : { ...style, maxWidth }}>
			{!isSSR ? (
				<Image
					alt={imgAlt}
					src={selectedImage.src}
					title={title}
					width={selectedImage.width}
					placeholder="empty"
					height={selectedImage.height}
					loading={lazy ? 'lazy' : 'eager'}
					quality={70}
					priority={priority}
					style={{
						maxWidth: '100%',
						height: 'auto'
					}}
				/>
			) : (
				<Skeleton height={fill ? '100%' : selectedImage.height} className={styles.skeletonPosition} />
			)}
		</article>
	)

	return link && !disabled ? (
		<Link prefetch={false} href={link} className={className} style={{ textDecoration: 'none' }} target="_blank">
			{bannerContent}
		</Link>
	) : (
		bannerContent
	)
}
